import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5f08eaa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.scss?vue&type=style&index=0&id=b5f08eaa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f08eaa",
  null
  
)

export default component.exports